var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MainImage"},[_c('img',{staticClass:"MainImage__image",attrs:{"src":require(("@/assets/images/panda/" + (_vm.getSelectedColor.code) + ".png"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }